import {useEffect, useState} from 'react';
import RangeSlider from '../../../../components/RangeSlider/RangeSlider';
import {useParamsFilter} from './helpers/useLoanFilters';

export const LOAN_AMOUNT_MIN = 100;
export const LOAN_AMOUNT_MAX = 500;

export default function LoanSliderFilter() {
  const {getFilter, setFilter} = useParamsFilter();

  const [amount, setAmount] = useState(
    () => getFilter('amount') || LOAN_AMOUNT_MIN.toString(),
  );

  useEffect(() => {
    setAmount(getFilter('amount') || LOAN_AMOUNT_MIN.toString());
  }, [getFilter]);

  const handleAmountChange = (value: number) => {
    const stringValue = value.toString();
    setAmount(stringValue);
    setFilter('amount', stringValue);
  };

  return (
    <div className="space-y-6">
      <div>
        <div className="flex justify-between mb-4">
          <h2 className="text-sm font-medium text-gray-800">
            میزان اعتبار درخواستی
          </h2>
          <span className="font-medium text-farm-shop-500 text-md">
            {(parseInt(amount) * 1000000).toLocaleString('fa-IR')} تومان
          </span>
        </div>

        <RangeSlider
          min={LOAN_AMOUNT_MIN}
          max={LOAN_AMOUNT_MAX}
          step={50}
          value={parseInt(amount)}
          onChange={handleAmountChange}
          formatLabel={v => `${v.toLocaleString('fa-IR')} میلیون`}
          ariaLabel="Select price"
          reverse={true}
        />
      </div>
    </div>
  );
}
